import Dashboard from "./components/Dashboard"

let module = "dashboard"

export default [
  {
    path: "dashboard",
    component: Dashboard,
    meta: { module: module, permissions: ["all"] }
  }
]
